import { render } from "./RpmPagination.vue?vue&type=template&id=0ff20046"
import script from "./RpmPagination.vue?vue&type=script&lang=js"
export * from "./RpmPagination.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__